import * as Cookie from './cookie'

export default Cookie
